import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { Position } from '@synergy/models';
import { noop } from '@synergy/utils';

import { Employee } from '../../features/user-management/models/employee';
import { EmployeeRequest } from '../../features/user-management/models/employee-request';

export class UserManagementApi {
    constructor(protected baseUrl: string) {}

    public cget = (
        customerAccountId: number,
        searchParams?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<Employee>>> => {
        const params = new URLSearchParams(searchParams);
        params.set('customerAccountId', customerAccountId.toString());
        return safeRequest(
            () => request.get(`${this.baseUrl}/contacts`, { params }),
            response => response.data
        );
    };

    public getPositions = (): Promise<ApiResult<Position[]>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/positions?limit=1000`),
            response => response.data
        );
    };

    public updateEmployee = (user: EmployeeRequest): Promise<ApiResult<void>> => {
        return safeRequest(() => request.patch(`${this.baseUrl}/contacts/${user.id}`, user), noop);
    };

    public updateMainContact = (mainContactId: number): Promise<ApiResult<void>> => {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/contacts/update-main-contact`, {
                    mainContactId,
                }),
            noop
        );
    };

    public updateImportContact = (importContactId: number): Promise<ApiResult<void>> => {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/contacts/update-import-contact`, {
                    importContactId,
                }),
            noop
        );
    };

    public createEmployee = (user: Omit<EmployeeRequest, 'id'>): Promise<ApiResult<Employee>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/contacts`, user),
            response => response.data
        );
    };

    public removeEmployee = (
        userId: number,
        assignMainContactId?: number,
        reassignBonusConditionsContactId?: number,
        reassignImportContactId?: number
    ): Promise<ApiResult<void>> => {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/contacts/${userId}/remove-employee`, {
                    assignMainContactId,
                    reassignBonusConditionsContactId,
                    reassignImportContactId,
                }),
            noop
        );
    };

    public deleteLoginUser = (userId: number): Promise<ApiResult<void>> => {
        return safeRequest(() => request.delete(`${this.baseUrl}/contacts/${userId}/user`), noop);
    };
}
